import { Component } from '@angular/core';
import { CloudinaryOptions, CloudinaryUploader } from 'ng2-cloudinary';
import { NgForm } from '@angular/forms';
import {AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable} from 'angularfire2/database';
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from 'toastr-ng2';
const swal = require('sweetalert');
@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationComponent  {

      siteVal:any;
     news:Array<any>;
         newsData: FirebaseListObservable<any>;

    constructor(public af:AngularFireDatabase, public router:Router,public toastr: ToastrService) {
     this.newsData= af.list('/FoonYew2');
         this.newsData.subscribe((res)=>{
         this.news = res;
     }); 
    }


  getnews(ev: any) {
        let val = ev;
        this.newsData = this.af.list('/FoonYew2', {
            query: {
                orderByChild: 'date',
                //startAt: val.charAt(0).toUpperCase() + val.slice(1),
                //endAt: val.charAt(0).toUpperCase() + val.slice(1) + '\uf8ff'
            }
        });
        this.newsData
            .subscribe((data) => {
                this.news = data;
            });


    }


   newsShow(key){
     this.router.navigate(['/notification/viewNotification', key]);
  }
  
   newsEdit(key){
    this.router.navigate(['/notification/editNotification', key]);
  }

   menuItemEdit(key){
    this.router.navigate(['/menu/editItems', key]);
  }
 
   newsDelete(key:any){
    swal({
            title: 'Are you sure?',
            text: 'Your will not be able to recover this data!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#DD6B55',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, cancel!',
            closeOnConfirm: false,
            closeOnCancel: false
        }, (isConfirm) => {
            if (isConfirm) {
               this.newsData.remove(key).then((res)=>{
                   swal('Deleted!','Notification Deleted Successfully!', 'success');
                 })
              } else {
                swal('Cancelled', 'Your data is safe :)', 'error');
            }
        });
  }
}



// WEBPACK FOOTER //
// /Users/sooweeseng/Documents/Ionic Apps/FoonYew2_Backend_ok_version/webapp/src/app/routes/restaurant/notifications/notifications.component.ts